module.exports = __webpack_public_path__ + "static/media/img3.e737ed09.png";